import { SpinnerFullPage } from '@updater/ui-uds';
import { PageRoutes } from 'constants/pageRoutes';
import { MicrositeContext } from 'context';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { useIsZipOnlyQual, useQual } from 'hooks';

// PromoIDs for AI agent flows — traffic with these promoIds routes to /choice instead of /quiz.
const AGENT_PROMO_IDS = [
  '5002967', // Xfinity (xfinityspecial.com)
  '5002982', // Spectrum (spectrumspecial.com)
];

/**
 * Why does this component handle quiz & landing page?
 * The app was originally built around the catch-all route, [[...quiz]].tsx,
 * as the first page the user lands on.
 *
 * For now we don't know what would break bc /services used to be the first page.
 * So we direct all users to /quiz/services or /landing here now.
 */
export const Redirector = () => {
  const router = useRouter();
  const isZipOnlyQual = useIsZipOnlyQual();
  const micrositeConfig = useContext(MicrositeContext);
  const { enableMicrositeLanding } = micrositeConfig ?? {};
  const { promoId } = useQual();

  useEffect(() => {
    // For ZIP-only quals, skip quiz/landing and go directly to offers
    if (isZipOnlyQual) {
      router.replace(PageRoutes.zipPlans);
      return;
    }

    if (promoId && AGENT_PROMO_IDS.includes(promoId)) {
      router.replace(PageRoutes.choice);
      return;
    }

    if (enableMicrositeLanding) {
      router.replace(PageRoutes.landing);
      return;
    } else {
      router.replace(PageRoutes.quiz);
      return;
    }
  }, [enableMicrositeLanding, router, isZipOnlyQual, promoId]);

  return <SpinnerFullPage />;
};
